import React, { useState } from "react";
import { withStyles, IconButton } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import styled from "styled-components";
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import ConfirmUserDelete from "./ConfirmUserDelete";

const StyledClickableRow = styled(TableRow)`
  :hover {
    cursor: pointer;
  }
`;

const styles = theme => ({
	root: {
		width: "100%",
		marginTop: theme.spacing(1) * 3,
		overflowX: "auto"
	},
	table: {
		minWidth: 700
	},
	icon: {
		padding: theme.spacing(1)
	}
});

function ClientsTable(props) {
	const { classes, onDelete } = props;
	const [dialogOpen, setDialogOpen] = useState(false);
	const [idToDelete, setIdToDelete] = useState(undefined);

	const handleClientDelete = (id) => {
		onDelete && onDelete(id);
		setDialogOpen(false);
	}

	const handleDeleteTry = (e, id) => {
		e.stopPropagation();
		setIdToDelete(id);
		setDialogOpen(true);
	};

	return (
		<Paper className={classes.root}>
			<Table className={classes.table}>
				<TableHead>
					<TableRow hover={true}>
						<TableCell>Nazwa Klienta </TableCell>
						<TableCell>Rodzaj</TableCell>
						<TableCell>Ulica i nr domu</TableCell>
						<TableCell>Kod pocztowy</TableCell>
						<TableCell>Miasto</TableCell>
						<TableCell>NIP</TableCell>
						<TableCell align="center">Usuń</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{props.clients.map(client => {
						return (
							<StyledClickableRow
								onClick={() => {
									props.onDialogSwitch(false);
									props.onSelectedIdChange(client.id_klient);
								}}
								hover={true}
								key={client.id_klient}
							>
								<TableCell>{client.nazwa}</TableCell>
								<TableCell>{client.rodzaj}</TableCell>
								<TableCell>{client.ulica}</TableCell>
								<TableCell>{client.kod}</TableCell>
								<TableCell>{client.miasto}</TableCell>
								<TableCell>{client.nip}</TableCell>
								<TableCell padding="none" align="center">
									<IconButton
										className={classes.icon}
										onClick={(e) => handleDeleteTry(e, client.id_klient)}
									>
										<DeleteSweepIcon />
									</IconButton>
								</TableCell>
							</StyledClickableRow>
						);
					})}
				</TableBody>
			</Table>
			<ConfirmUserDelete
				open={dialogOpen}
				onClose={() => setDialogOpen(false)}
				onSubmit={() => handleClientDelete(idToDelete)}
			/>
    </Paper>
  );
}

export default withStyles(styles)(ClientsTable);
